import { render, staticRenderFns } from "./ProjectQuoteSubmissions.vue?vue&type=template&id=9a1f2ab6&scoped=true&"
import script from "./ProjectQuoteSubmissions.vue?vue&type=script&lang=js&"
export * from "./ProjectQuoteSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./ProjectQuoteSubmissions.vue?vue&type=style&index=0&id=9a1f2ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1f2ab6",
  null
  
)

export default component.exports